export default __webpack_public_path__ + "images/V9.6d9661d.png";